import styled from 'styled-components';

import { colors } from '../../../../../utils/utils';

const Label = styled.span`
    color: ${colors.gray.basic};
`;

export default Label;
